<template>
  <section class="home-hero">
    <div class="overlay">
      <img :src="logo" alt="NightKill Logo" class="logo animate-target" />
      <p class="tagline animate-target">Melodic Heavy Metal from Greece</p>
      <!-- <p class="new-info animate-target">
        Our new lyric video is live! Click
        <router-link
          :to="{ path: '/media', query: { video: '3' } }"
          class="new-info-link"
          >HERE</router-link
        >
        to watch!
      </p> -->
    </div>
    <div class="video-wrapper">
      <video
        autoplay
        muted
        loop
        playsinline
        disablePictureInPicture
        class="hero-video"
        poster="/media/video/poster.webp"
      >
        <source src="/media/video/intro_h264.mp4" type="video/mp4" />
        <source src="/media/video/intro_av1.mp4" type="video/mp4" />
      </video>
    </div>
  </section>
</template>

<script>
import logo from '@/assets/NightKill-Logo.png';
import { useHead } from '@vueuse/head';

export default {
  name: 'HomeView',

  data() {
    return {
      logo,
    };
  },
  mounted() {
    useHead({
      title: 'NightKill Official',
      meta: [
        {
          name: 'description',
          content:
            'Official site of NightKill — melodic heavy metal from Greece. Discover tour dates, merch, music, and band news.',
        },
        {
          name: 'keywords',
          content:
            'NightKill, melodic heavy metal, Greece band, rock music, metal tour, band merch',
        },

        {
          name: 'geo.region',
          content: 'GR-ATH',
        },
        {
          name: 'geo.placename',
          content: 'Athens',
        },
        {
          name: 'geo.position',
          content: '37.9838;23.7275',
        },

        // Open Graph
        {
          property: 'og:title',
          content: 'NightKill | Melodic Heavy Metal from Greece',
        },
        {
          property: 'og:description',
          content:
            'Discover NightKill — Greek melodic heavy metal. Tour updates, music, merch and more.',
        },
        {
          property: 'og:image',
          content: 'https://nightkill.gr/metadata/nightkill-logo.png',
        },
        { property: 'og:url', content: 'https://nightkill.gr/' },
        { property: 'og:type', content: 'website' },
        { property: 'og:site_name', content: 'NightKill Official' },

        // Twitter
        { name: 'twitter:card', content: 'summary_large_image' },
        {
          name: 'twitter:title',
          content: 'NightKill | Melodic Heavy Metal from Greece',
        },
        {
          name: 'twitter:description',
          content:
            'Follow NightKill — Greece’s melodic metal force. Get band updates, music and merch.',
        },
        {
          name: 'twitter:image',
          content: 'https://nightkill.gr/metadata/nightkill-logo.png',
        },
      ],
      link: [{ rel: 'canonical', href: 'https://nightkill.gr/' }],

      script: [
        {
          type: 'application/ld+json',
          children: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'MusicGroup',
            name: 'NightKill',
            genre: 'Melodic Heavy Metal',
            location: {
              '@type': 'Place',
              name: 'Athens, Greece',
              address: {
                '@type': 'PostalAddress',
                addressLocality: 'Athens',
                addressCountry: 'GR',
              },
            },
            url: 'https://nightkill.gr',
          }),
        },
      ],
    });

    this.$nextTick(() => {
      setTimeout(() => {
        const heroSection = this.$el;
        if (heroSection) {
          heroSection.classList.add('is-loaded');
        }
      }, 100);
    });
  },
};
</script>

<style scoped>
.home-hero {
  position: relative;
  height: 80vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.logo.animate-target {
  opacity: 0;
  transform: scale(0.9);
  transition: opacity 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    transform 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.tagline.animate-target {
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.6s ease-out 0.4s, transform 0.6s ease-out 0.4s;
}

.new-info.animate-target {
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.6s ease-out 0.4s, transform 0.6s ease-out 0.4s;
  transition-delay: 1s;
}

.home-hero.is-loaded .logo.animate-target {
  opacity: 1;
  transform: scale(1);
}

.home-hero.is-loaded .tagline.animate-target {
  opacity: 1;
  transform: translateY(0);
}

.home-hero.is-loaded .new-info.animate-target {
  opacity: 1;
  transform: translateY(0);
}

.logo {
  width: 80%;
  max-width: 800px;
  filter: drop-shadow(0 0 15px rgba(0, 0, 0, 0.7));
}

.tagline,
.new-info {
  color: #e0e0e0;
  font-size: 1.3rem;
  font-family: 'Cinzel Decorative', cursive;
  font-weight: 700;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.8);
  margin-top: -1rem;
}

.video-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: -1;
}

.hero-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.overlay {
  z-index: 1;
  position: relative;
  text-align: center;
}

.new-info-link {
  color: #42b983;
}
</style>
